import { useCallback, useState } from 'react';

import Formsy from "formsy-react";
import { Copy } from 'lucide-react';
import { FormGroup, DefaultTooltip, Button, Row, Col, Label } from 'twyne-new.ui';

import ConfirmationPopover from '@/components/ConfirmationPopover';
import Input from '@/components/form/Input';
import InputDecimal from '@/components/form/InputDecimal';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

import { useRewardStore } from '../../../store';

export default function DuplicateEntity({ info }) {
  const [open, setOpen] = useState(false)

  const { definitions: { entityName }, handleRefresh } = useGrid()
  const { duplicateReward } = useRewardStore()
  const { handleSuccess } = useAppAlert()

  const { row } = getInfo(info)

  const handleSubmit = useCallback(async data => {
    setOpen(false)
    await duplicateReward({ ...row, ...data })
    await handleRefresh()
    handleSuccess(`${entityName} duplicated!`)
  }, [duplicateReward, handleSuccess, entityName, row, handleRefresh])

  return <>
    <ConfirmationPopover
      open={open}
      onOpenChange={setOpen}
      target={<DefaultTooltip content='Duplicate' side='left'><Copy size={16} /></DefaultTooltip>}
      title={<span>Duplicate {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name}`}</i></span>}
    >
      <Formsy onValidSubmit={handleSubmit}>
        <Row>
          <Col size="12">
            <FormGroup>
              <Label>New Reward Name</Label>
              <Input name="name" required />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>New amount</Label>
              <InputDecimal name="amount" required />
            </FormGroup>
          </Col>
          <Col size="12">
            <Button color="danger" type="submit" block>Yes, I am sure</Button>
          </Col>
        </Row>
      </Formsy>
    </ConfirmationPopover>
  </>
}
